import { type UseTooltipProps, useTooltipDefault } from "./useTooltip";

import type { ElementType, PropsWithChildren } from "react";

export const useTooltip = useTooltipDefault;

type Props = {
  as?: ElementType;
  className?: string;
  tooltipClassName?: string;
  focusDisabled?: boolean;
};

export function Tooltip(props: PropsWithChildren<Props & UseTooltipProps>) {
  const { className, children, content, as: Component = "span" } = props;
  if (content) {
    return <ActiveTooltip {...props} />;
  }
  return <Component className={className}>{children}</Component>;
}

export function ActiveTooltip({
  className,
  tooltipClassName,
  focusDisabled,
  children,
  as: Component = "span",
  ...props
}: PropsWithChildren<Props & UseTooltipProps>) {
  const { handlerProps, tooltip } = useTooltip({
    focusProps: {
      enabled: !focusDisabled,
    },
    className: tooltipClassName,
    ...props,
  });

  return (
    <Component {...handlerProps} className={className}>
      {children}
      {tooltip}
    </Component>
  );
}

export function TooltipShortcut({ children }: PropsWithChildren) {
  return <span className="ml-[22px] text-gray-400">{children}</span>;
}
